import {
  MaritalStatusEntries,
  MaritalStatusLookup,
  type MaritalStatusCode,
} from '@/lib/maritalstatus';
import type { BasicSelectProps } from './types';
import type { SharedSelection } from '@heroui/react';
import { Input, Select, SelectItem } from '@heroui/react';

export type Props = {
  selected?: string | string[];
  isReadOnly?: boolean;
  value?: MaritalStatusCode;
  onSingleChange?: (value: MaritalStatusCode) => void;
  onMultiChange?: (value: MaritalStatusCode[]) => void;
} & BasicSelectProps;

export function MaritalStatusSelect({
  label,
  placeholder,
  multiple,
  value,
  onChange,
  onSingleChange,
  onMultiChange,
  startContent,
  className,
  isReadOnly,
}: Props) {
  const list = MaritalStatusEntries;
  const lookup = MaritalStatusLookup;
  // const onChangeHandler = makeOnChangeHandler({
  //   anyTarget: onChange,
  //   multiple,
  // });
  const selectionHandler = (keys: SharedSelection) => {
    if (!onChange && !onSingleChange && !onMultiChange) {
      return;
    }

    if (multiple) {
      const values = (
        Array.isArray(keys) ? keys : [keys as string]
      ) as MaritalStatusCode[];
      onChange?.(values);
      onMultiChange?.(values);
    } else if (keys instanceof Set && !keys.size) {
      onChange?.(undefined);
      onMultiChange?.([]);
    } else {
      onChange?.(keys.currentKey);
      onSingleChange?.(keys.currentKey as MaritalStatusCode);
    }
  };

  const selectedKeys =
    (Array.isArray(value) ? value : [value]).filter((s) => s !== undefined) ||
    [];

  if (isReadOnly) {
    const display = selectedKeys
      .map((key) => lookup[key as MaritalStatusCode]?.label || '')
      .filter((label) => label?.length)
      .join(', ');

    return (
      <Input isReadOnly value={display} className={className} label={label} />
    );
  }

  return (
    <>
      <Select
        label={label}
        aria-label='Marital Status'
        placeholder={placeholder}
        startContent={startContent}
        className={className}
        selectedKeys={selectedKeys}
        onSelectionChange={selectionHandler}
        selectionMode={multiple ? 'multiple' : 'single'}
        items={list}
      >
        {(item) => (
          <SelectItem key={item.key} textValue={item.label}>
            {item.label}
          </SelectItem>
        )}
      </Select>
    </>
  );
}
